import { MenuCategoryDetailPage } from "@/features/menu-category/pages/MenuCategoryDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/menu-category/$id/detail")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <MenuCategoryDetailPage id={id} />;
}
